"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NFT = void 0;
const node_1 = require("./node");
const types_1 = require("../types");
class NFT extends node_1.Node {
    constructor(nodeLike) {
        super(nodeLike, null);
        this.ticker = nodeLike.ticker;
        this.name = nodeLike.name;
        this.description = nodeLike.description;
        this.collection = nodeLike.collection;
        this.creator = nodeLike.creator;
        this.balances = nodeLike.balances;
        this.claimable = nodeLike.claimable;
        this.asset = new types_1.FileVersion(nodeLike.asset);
        this.thumbnail = nodeLike.thumbnail ? new types_1.FileVersion(nodeLike.thumbnail) : undefined;
        this.uri = this.getUri();
    }
    getUri(type = node_1.StorageType.ARWEAVE) {
        var _a, _b;
        const uri = (_a = this.asset) === null || _a === void 0 ? void 0 : _a.getUri(type);
        return uri ? uri : (_b = this.asset) === null || _b === void 0 ? void 0 : _b.getUri(node_1.StorageType.S3);
    }
}
exports.NFT = NFT;
